import { EModuleType } from "./EModuleType";
import { EArmType } from "./Waypoint";
import { ImagerCapability } from "./ImagerCapabilities";
import { PsrCapabilities } from "./PsrCapabilites";
export interface Module {
  name: string;
  status: string;
  identifier: string;
  moduleType: EModuleType;
}

export enum EHotelType
{
  Unknown,
  SBS,
  LCP,
  Linbro,
  Nextal,
  Terazaki
}

export interface ModuleCapabilities {
  isHardwareDisconnected: boolean;
  identifier: string;
  imager?: ImagerCapability;
  psr?: PsrCapabilities;
  loadPort?: LoadPortCapabilities;
  chamber?: ChamberCapabilities;
  chiller?: ChillerCapabilities;
}

export interface LoadPortCapabilities {
  supportedArmTypes: EArmType[];
  hotelTypes: EHotelType[];
}

export interface ChamberCapabilities {
  supportedArmTypes: EArmType[];
}

export interface ChillerCapabilities {}
